export default {
	getAll(datafield) {},
}
